import { dependencies } from '@pn/core/dependencies';
import type { WorkspaceItem } from '@pn/core/domain/workspace';
import { isNil, omit, pick } from 'lodash-es';
import type { State } from './workspaceSlice';

/* Creates a circular dependency if placed in workspaceStorage.ts */

export function getWorkspaceSnapshot(): {
  selectedWorkspaceItem: WorkspaceItem | undefined;
  workspace: Record<string, WorkspaceItem>;
  library: Record<string, WorkspaceItem>;
  all: Record<string, WorkspaceItem>;
} {
  const { workspaceItemIdSelected, idsInWorkspace, allWorkspaceItems } =
    dependencies.store.getState().workspace as State;

  const selectedWorkspaceItem = !isNil(workspaceItemIdSelected)
    ? allWorkspaceItems[workspaceItemIdSelected]
    : undefined;

  return {
    selectedWorkspaceItem,
    workspace: pick(allWorkspaceItems, idsInWorkspace),
    library: omit(allWorkspaceItems, idsInWorkspace),
    all: allWorkspaceItems,
  };
}
